// src/createKbdPlugin.ts
import {
  createPluginFactory,
  onKeyDownToggleMark
} from "@udecode/plate-common/server";
var MARK_KBD = "kbd";
var createKbdPlugin = createPluginFactory({
  deserializeHtml: {
    rules: [{ validNodeName: ["KBD"] }]
  },
  handlers: {
    onKeyDown: onKeyDownToggleMark
  },
  isLeaf: true,
  key: MARK_KBD
});
export {
  MARK_KBD,
  createKbdPlugin
};
//# sourceMappingURL=index.mjs.map